import React, { Component } from 'react';
import styles from './index.css';
import SimpleLineIcon from 'react-simple-line-icons';


export default class ChooseDifficulty extends Component {
  state = {difficulty:'easy'};
  render() {
    return (
      <div className={styles.chooseDifficulty}>
        <h3>Вибір рівня складності</h3>
        <div className={styles.difficultyVariants}>
          <div className={styles.variant + ((this.state.difficulty === 'easy') ? " " + styles.active : '')}>
            <div className={styles.variantPic + ' ' + styles.easy} />
            <h3>ПОЧАТКОВИЙ</h3>
            <p>Немає відхилів від графику приймання та відгрузки, немає випадкових явищ, вплив затримок у обробці обороту культур та запитів минимальний. Ідеально для першого досвіду моделювання елеватора.</p>
            {this.state.difficulty === 'easy' &&
              <SimpleLineIcon name="check" size="large" style={{color:'#7ed321'}}/>
            }
            {this.state.difficulty !== 'easy' &&
              <div className={styles.button} onClick={() => {
                this.setState({difficulty: 'easy'})
              }}>ОБРАТИ</div>
            }
          </div>
          <div className={styles.variant + ((this.state.difficulty === 'advanced') ? " " + styles.active : '')}>
            <div className={styles.variantPic + ' ' + styles.advanced} />
            <h3>Досвідчений</h3>
            <p>Помітні відхилення від графику приймання та відгрузки в залежності від рейтингу елеваториста, інколи виникають випадкові явища, які заважають роботі різних вузлів елеватора. Підійде досвідченим елеватористам.</p>
            {this.state.difficulty === 'advanced' &&
              <SimpleLineIcon name="check" size="large" style={{color:'#7ed321'}}/>
            }
            {this.state.difficulty !== 'advanced' &&
              <div className={styles.button} onClick={() => {
                this.setState({difficulty: 'advanced'})
              }}>ОБРАТИ</div>
            }
          </div>
          <div className={styles.variant + ((this.state.difficulty === 'expert') ? " " + styles.active : '')}>
            <div className={styles.variantPic + ' ' + styles.expert} />
            <h3>ЕКСПЕРТ</h3>
            <p>Рейтинг елеваториста суттєво впливає на відхилення від графику приймання та відгрузки, випадкові явища частіше та мають більший вплив на процеси.<br/>Для справжніх експертів елеваторного бізнесу.</p>
            {this.state.difficulty === 'expert' &&
              <SimpleLineIcon name="check" size="large" style={{color:'#7ed321'}}/>
            }
            {this.state.difficulty !== 'expert' &&
              <div className={styles.button} onClick={() => {
                this.setState({difficulty: 'expert'})
              }}>ОБРАТИ</div>
            }
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/shared/components/EquipComponents/ChooseDifficulty/index.js